import './consumption-hours.component.css';

export const ConsumptionHoursSlide = ({
    consumptionHour,
    onConsumptionHourChange,
    onContinue
}: {
    consumptionHour: string;
    onConsumptionHourChange: (value: string) => void;
    onContinue: () => void;
}) => {
    // Constants
    const consumptionsHours = [{
        value: "RE",
        label: "Estándar",
        icon: require('../../assets/consumption-standard.png')
    }, {
        value: "RT",
        label: "Teletrabajo",
        icon: require('../../assets/consumption-virtual.png')
    }];

    return (<div className="row consumption-hours">
        <div className="col-6">
            <h2>
                ¿Cuáles son tus <span className="inverted">horas habituales</span> de consumo?
            </h2>
            <hr className="separator green-gradient"></hr>
            <p className="p-large">Si trabajas fuera de casa, selecciona la opción <strong>"estándar".</strong></p>
            <p className="p-large">Si teletrabajas, selecciona la opción <strong>"teletrabajo".</strong></p>
            <br />
            <p className="p-large">Gracias a los tramos de consumo habituales podremos optimizar tus costes.</p>
            <br />
            <br />
            <button disabled={!consumptionHour} onClick={() => { onContinue(); }} className="button">
                Continuar
            </button>
        </div>
        <div className="col-6">
            {
                consumptionsHours.map(({ icon, label, value }, i) => 
                    <button key={`consumption-hours--option--${i}`}
                        className={`fake-input${consumptionHour === value ? ' selected' : ''} button`}
                        onClick={() => { onConsumptionHourChange(value); }}
                    >
                        <img src={icon} alt={label} />
                        {label}
                    </button>
                )
            }
        </div>
    </div>);
}